import { useState } from 'react';
import { LayoutModule } from '../../../layout/modules';
import { Submotive4Filters } from './filters';
import { Submotive4List } from './list';
import { SUBMOTIVE4, SUBMOTIVE4_NEW } from '../../../../routes/paths';
import ActionButtonGroup from '../../../components/general/buttons/actionButtonGroup';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { isOnlyViewProfile } from '../../../../shared/types/profiles';
import { Param } from '../../../../shared/types/param';

export const Submotive4 = () => {
    const [filters, setFilters] = useState<Param>();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    return (
        <>
            <LayoutModule
                title="Búsqueda de submotivo 4"
                showTitle
                additionalButtons={
                    <ActionButtonGroup
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: SUBMOTIVE4_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: SUBMOTIVE4,
                        }}
                    />
                }
            >
                <Submotive4Filters
                    onFilter={(filters) => setFilters(filters)}
                />
            </LayoutModule>
            <Submotive4List filters={filters} />
        </>
    );
};
